module.exports = __webpack_public_path__ + "static/media/adjustment-tiles.5f416ae0.png";